/**
 * @generated SignedSource<<2ac6618e041917fabbdd334ec73d4edd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type composerQueriesImagesQueriesQuery$variables = {
  categoryID?: string | null;
  count: number;
  cursor?: string | null;
  isBackground: boolean;
  isLibrary?: boolean | null;
  search?: string | null;
  sellerID?: number | null;
};
export type composerQueriesImagesQueriesQuery$data = {
  readonly images: {
    readonly edges: ReadonlyArray<{
      readonly cursor: string;
      readonly node: {
        readonly __typename: "Image";
        readonly categories: ReadonlyArray<{
          readonly categoryID: number;
          readonly name: string | null;
        }> | null;
        readonly choiceUrl: string | null;
        readonly code: string | null;
        readonly firstCategoryID: number | null;
        readonly id: string;
        readonly isImageEnabled: boolean;
        readonly name: string;
        readonly numberOfProducts: number;
        readonly preferredHeight: number | null;
        readonly preferredWidth: number | null;
        readonly previewUrl: string | null;
        readonly price: number;
        readonly url: string | null;
      };
    }> | null;
    readonly pageInfo: {
      readonly endCursor: string | null;
      readonly hasNextPage: boolean;
    };
  } | null;
};
export type composerQueriesImagesQueriesQuery = {
  response: composerQueriesImagesQueriesQuery$data;
  variables: composerQueriesImagesQueriesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "categoryID"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "count"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cursor"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isBackground"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isLibrary"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "search"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sellerID"
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v8 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "after",
        "variableName": "cursor"
      },
      {
        "kind": "Variable",
        "name": "categoryID",
        "variableName": "categoryID"
      },
      {
        "kind": "Variable",
        "name": "first",
        "variableName": "count"
      },
      {
        "kind": "Variable",
        "name": "isBackground",
        "variableName": "isBackground"
      },
      {
        "kind": "Variable",
        "name": "isLibrary",
        "variableName": "isLibrary"
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      },
      {
        "kind": "Variable",
        "name": "sellerID",
        "variableName": "sellerID"
      }
    ],
    "concreteType": "ImagesConnection",
    "kind": "LinkedField",
    "name": "images",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ImagesEdge",
        "kind": "LinkedField",
        "name": "edges",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "Image",
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              (v7/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "choiceUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "previewUrl",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preferredWidth",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "preferredHeight",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Category",
                "kind": "LinkedField",
                "name": "categories",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "categoryID",
                    "storageKey": null
                  },
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "numberOfProducts",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "price",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "code",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "url",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "isImageEnabled",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "firstCategoryID",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cursor",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "PageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "endCursor",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasNextPage",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "composerQueriesImagesQueriesQuery",
    "selections": (v8/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v2/*: any*/),
      (v5/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Operation",
    "name": "composerQueriesImagesQueriesQuery",
    "selections": (v8/*: any*/)
  },
  "params": {
    "cacheID": "2285eb77721ef84999186f21e21ca06a",
    "id": null,
    "metadata": {},
    "name": "composerQueriesImagesQueriesQuery",
    "operationKind": "query",
    "text": "query composerQueriesImagesQueriesQuery(\n  $count: Int!\n  $cursor: String\n  $search: String\n  $categoryID: ID\n  $isLibrary: Boolean\n  $sellerID: Long\n  $isBackground: Boolean!\n) {\n  images(first: $count, after: $cursor, search: $search, categoryID: $categoryID, isLibrary: $isLibrary, sellerID: $sellerID, isBackground: $isBackground) {\n    edges {\n      node {\n        id\n        name\n        choiceUrl\n        previewUrl\n        preferredWidth\n        preferredHeight\n        categories {\n          categoryID\n          name\n        }\n        numberOfProducts\n        price\n        code\n        url\n        isImageEnabled\n        firstCategoryID\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "f10290c1201c0ad766a15ef452a166d5";

export default node;
